import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { operacion } from '../../models/operacion';
import InputNumber from '../../../../components/inputs/yup/materialui/inputNumber';
import { Card, CardContent, Grid2, Typography } from '@mui/material';
import { selectorTransversal } from '../../../../dtos/selector';
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';

interface IAdquisicion {
    control: Control<operacion>;
    adquisicion: selectorTransversal[];
    isEditing: boolean;
    errors: FieldErrors<operacion>;
    isComplementario: boolean;
    esVigente?: boolean;
     isReadonlyWithPermission : () => boolean;
}

const AdquisicionForm: React.FC<IAdquisicion> = ({ control, adquisicion, isEditing, errors, isComplementario, esVigente, isReadonlyWithPermission }) => {

    return (
        <Card sx={{ mb: 2, backgroundcolor: 'white' }} raised>
            <CardContent>
                <Typography className='card-title' variant="h6" gutterBottom>
                    Datos de adquisición
                </Typography>
                <Grid2 container spacing={2} sx={{ mt: 2 }}>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            label='Adquisición'
                            name='adquisicion'
                            control={control}
                            options={adquisicion}
                            disabled={isReadonlyWithPermission()}
                            error={errors.adquisicion}
                        // error={errors.sexo}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Provisión banco"
                            name="refinancProvBanco"
                            control={control}
                            prefix="CLP"
                            disabled={isReadonlyWithPermission()}
                            error={errors.refinancProvBanco}    
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Liquidación prepago vendedor"
                            name="liquidacionPrepagoVendedor"
                            control={control}
                            prefix="CLP"
                            disabled={isReadonlyWithPermission()}
                            error={errors.liquidacionPrepagoVendedor}
                        />
                    </Grid2>
                </Grid2>
            </CardContent>
        </Card >
    );
};

export default AdquisicionForm;